const constant = {
  // appBaseUrl: "http://localhost:7200",
  appBaseUrl: "https://dev.realtyshopee.in/BE",
  // appBaseUrl: "https://stage.realtyshopee.in/BE",
  // appBaseUrl: "https://realtyshopee.in/BE",

  // appBaseUrl: "http://32.193.35.12/BE",
  updateBiodata: false,
};
export default constant;
